import { mapObjIndexed } from 'ramda';

export const customTableSettings = {
  prop_mmAspectElektronickypodpis_Podepisujiciosoby: {
    constraints: [
      {
        fieldId: 'Jmeno',
        id: 'MANDATORY',
        validationHandler: 'Alfresco.forms.validation.mandatory',
      },
      {
        fieldId: 'Prijmeni',
        id: 'MANDATORY',
        validationHandler: 'Alfresco.forms.validation.mandatory',
      },
      {
        fieldId: 'Email',
        id: 'MANDATORY',
        validationHandler: 'Alfresco.forms.validation.mandatory',
      },
      {
        fieldId: 'Email',
        id: 'REGEX',
        validationHandler: 'Alfresco.forms.validation.email',
      },
    ],
    getFields: function (fields) {
      const fieldsVisibility = {
        Jmeno: true,
        Prijmeni: true,
        Email: true,
        Telefon: true,
      };

      const mandatoryFields = {
        Jmeno: true,
        Prijmeni: true,
        Email: true,
      };

      return mapObjIndexed((value, key) => {
        if (fieldsVisibility[key]) {
          return {
            ...value,
            mandatory: mandatoryFields[key] || false,
            placeholder: key === 'Telefon' ? window.Alfresco.messages.global['signiIntegration.phone-placeholder'] : '',
          };
        }

        return {
          ...value,
          control: {
            ...value.control,
            template: '/org/alfresco/components/form/controls/hidden.ftl',
          },
        };
      }, fields);
    },
  },
};
